import React, {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import Loader from "../../../components/common/Loader";
import TextEditorContent from "../../../components/TextEditorContent";
import DiscussionsCommentList from "../../../components/DiscussionsCommentList";
import {CommentsService} from "../../../services/commentsService/commentsService";
import UserDetails from "../../../components/UserDetails";
import CustomBreadcrumbs from "../../../components/CustomBreadcrumbs/CustomBreadcrumbs";
import {AiFillHeart, AiOutlineHeart} from "react-icons/ai";
import {toast} from "react-toastify";

const CommentDetails = () => {
    const [commentDetails, setCommentDetails] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const { id } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
        getCommentDetails();
    }, []);

    const getCommentDetails = async () => {
        setIsLoading(true);
        try {
            const response = await CommentsService.getCommentDetails(id);
            setCommentDetails(response.data);
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    };

    const commentActionPathByType = () => {
        switch (commentDetails?.related_to?.type) {
            case 'master-classes':
                return `master-classes/${commentDetails?.related_to?.id}`;
            case 'lessons':
                return `lessons/${commentDetails?.related_to?.id}`;
            case 'community-questions':
                return `community/community-questions/${commentDetails?.related_to?.id}`;
            case 'member-discussions':
                return `community/member-discussions/${commentDetails?.related_to?.id}`;
            default:
                return null;
        }
    };

    const breadcrumbPagesByType = () => {
        switch (commentDetails?.related_to?.type) {
            case 'master-classes':
                return [
                    {
                        title: commentDetails?.related_to?.name,
                        to: `/master-classes/${commentDetails?.related_to?.id}`
                    },
                ];
            case 'lessons':
                return [
                    {
                        title: commentDetails?.related_to?.name,
                        to: `/lessons/${commentDetails?.related_to?.id}`
                    },
                ];
            case 'community-questions':
                return [
                    {
                        title: 'Questions for the Community',
                        to: `/community/questions-for-the-community`
                    },
                    {
                        title: commentDetails?.related_to?.name,
                        to: `/community/questions-for-the-community/${commentDetails?.related_to?.id}`
                    },
                ];
            case 'member-discussions':
                return [
                    {
                        title: 'Member Discussions',
                        to: `/community/member-discussions`
                    },
                    {
                        title: commentDetails?.related_to?.name,
                        to: `/community/member-discussions/${commentDetails?.related_to?.id}`
                    },
                ];
            default:
                return null;
        }
    };

    const commentActionType = commentActionPathByType();
    const pages = breadcrumbPagesByType();

    const handleLike = async () => {
        try {
            const response = await CommentsService.likeComment(commentActionType, commentDetails.id);
            setCommentDetails(response.data);
            toast.success('Done!');
        } catch (err) {
            toast.error('Like comment failed. Please try again.');
        }
    };

    return (
        <>
            <div className="container-fluid">
                {isLoading ? (
                    <Loader />
                ) : (
                    <>
                        <CustomBreadcrumbs
                            currentPageTitle={'Comments'}
                            pages={pages}
                        />
                        <div className="container m-4">
                            <div className="row">
                                <div className="col-lg-6 col-md-12">
                                    <div className="mb-2" onClick={() => navigate(`/community/users/${commentDetails?.user.id}`)}>
                                        <UserDetails user={commentDetails?.user} />
                                    </div>
                                    <TextEditorContent
                                        text={commentDetails?.body}
                                    />
                                    <div className="d-flex justify-content-end align-items-center" onClick={handleLike}>
                                        {commentDetails?.is_liked ? (
                                            <AiFillHeart
                                                fill="red"
                                                fontSize={30}
                                                style={{cursor: "pointer"}}
                                            />
                                        ) : (
                                            <AiOutlineHeart
                                                fontSize={30}
                                                style={{cursor: "pointer"}}
                                            />
                                        )}
                                        <span className="fs-5 fw-bold discussion-topic__likes-count">
                                            {commentDetails?.likes_count}
                                        </span>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-12">
                                    <div className="master-class__comments">
                                        <DiscussionsCommentList
                                            getDataPath={`comments/${id}/replies`}
                                            customPath={true}
                                            path={commentActionType}
                                            title="Replies"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </div>
        </>
    );
};

export default CommentDetails;